const commonApi = {
  //首页余额记录
  getIndex: { method: "post", url: "/api/index/index" },
  //获取账单记录
  getBill: { method: "post", url: "/api/index/bill2" },
  //意见反馈
  addFeedback: { method: "post", url: "/api/feedback/addFeedback" },
  //投诉
  addComplain: { method: "post", url: "/api/feedback/addComplain" },
  //导出账单记录
  excel: { method: "get", url: "/api/index/excel" },
  // 修改密码日志
  updateLog: { method: "get", url: "/api/user/update_password_list" },
  //首页对账整体情况
  getReconciliationTotal: { method: "post", url: "/api/index/dzh" },
  //对账函所有对账单列表
  getReconciliationMxList: { method: "post", url: "/api/index/dzhMxList" },
  //获取对账单页面
  getDzhDetail: { method: "get", url: "/api/index/dzhDeatail" },
  //保存对账单对账结果
  saveDzjg: { method: "post", url: "/api/index/saveDzjg" },
  //保存对账单对账结果
  saveDzjgAndConfirm: { method: "post", url: "/api/index/saveDzjgAndConfirm" },
};

export default commonApi;
